angular.module("bachecaComunicazioni.components", []).component("bachecaComunicazioni", {
    templateUrl: "ng/components/bachecaComunicazioni/bachecaComunicazioni.view.html",
    bindings: {

    },
    controllerAs: "bachecaComunicazioniCtrl",
    controller: function BachecaComunicazioni($notificationService, $configService, $download) {
        var self = this;

        self.$onInit = function () {
            self.supportModel = {
                notificationList: [],
                isPending: true,
                toggleNext: [],
            }
            self.notificList = [],
                self.getNotificationsByUser();
        }

        self.getNotificationsByUser = function () {
            $notificationService.getNotificationsByUser()
                .then(function (response) {
                    self.supportModel.notificationList = response
                    self.notificList = response
                    for (var i = 0; i < self.notificList.length; i++) {
                        self.supportModel.toggleNext[i] = false;
                    }
                    self.supportModel.isPending = false;
                })
                .catch(function () {
                    self.supportModel.isPending = false;
                })
        }

        self.readNotification = function (notification) {
            var index = self.notificList.findIndex(function (element) {
                return element.id == notification.id;
            })
            $notificationService.readNotification(notification.id)
                .then(function () {
                    self.lastNotification = notification.id;
                    notification.read = true;
                    if (index < self.notificList.length) {
                        self.supportModel.toggleNext[index + 1] = true;
                    }
                });
        }

        self.generatePdfDownloadLink = function (pdfLink) {
            // GET notification ID
            var url = "/uni/downloadGenericBacheca/service-infos/BACHECA/NEWS/" +
                encodeURIComponent(pdfLink) +
                "/" +
                encodeURIComponent(null) + "/"


            $download.getGenericDownload(url)
                .then(function (response) {
                    console.log(response);
                })
        };
    }
});